import { useEffect, useState } from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import About from "./components/About";
import Services from "./components/Services";
import Highlights from "./components/Highlights";
import Portfolio from "./components/Portfolio";
import Process from "./components/Process";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BookingModal from "./components/BookingModal";
import { Toaster } from "./components/ui/toaster";
import { useGsapScroll } from "./hooks/useGsapScroll";

function App() {
  useGsapScroll();
  const [bookingOpen, setBookingOpen] = useState(false);

  useEffect(() => {
    // Any [data-book] click opens the modal
    const handler = (e) => {
      const t = e.target.closest("[data-book]");
      if (t) {
        e.preventDefault();
        setBookingOpen(true);
      }
    };
    document.addEventListener("click", handler);
    window.openBooking = () => setBookingOpen(true);
    return () => document.removeEventListener("click", handler);
  }, []);

  useEffect(() => {
    if (bookingOpen) window.lenis?.stop();
    else window.lenis?.start();
  }, [bookingOpen]);

  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: "0px 0px 60px 0px" }
    );
    document.querySelectorAll(".reveal").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="App bg-white">
      <div className="grain" />
      <Navbar />
      <Hero />
      <Marquee />
      <About />
      <Highlights />
      <Services />
      <Portfolio />
      <Process />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
      <BookingModal open={bookingOpen} onOpenChange={setBookingOpen} />
      <Toaster />
    </div>
  );
}

export default App;
